module.exports = __webpack_public_path__ + "static/media/temp_20.e4566b4f.jpg";